<template>
	<el-row class="maintwobox">
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<div class="mainOnebox_main_list">
				<img src="@/assets/image/home/map.png">
				<el-row>
					<el-row class="mainOnebox_main_list_name1"> <span class="el-icon-location" ></span> ADD
					</el-row>
					<el-row class="mainOnebox_main_list_name2">
						<span>B2-308D , Jiangcun Business Center830 Wenyixi Rd , Hangzhou , ZhejiangChina 310030</span> <br><br>
						<br><br>
					</el-row>
				</el-row>
			</div>

		</el-row>
	</el-row>
</template>

<script>
	// import banner from './components/banner.vue';

	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {

			}
		},
		methods: {

		},

	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.maintwobox {
		width: 100%;
		height: auto;
		background: #fff;
		padding-top: 5.2vw;

		.mainOnebox_main {
			width: 100%;
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;

			.mainOnebox_main_list {
				width: 100%;
				height: auto;
				margin: 1vh 1.5vw;
				border-radius: 5px;
				overflow: hidden;
				display: flex;
				align-items: center;
				text-align: left;
				margin-top: 110/@vw;
				margin-bottom: 100/@vw;
				img {
					width: 616/@vw;
					height: 466/@vw;
					border-radius: 1vw;
					margin-left: 3vw;
				}

				.mainOnebox_main_list_name1 {
					max-width: 414px;
					font-weight: 700;
					color: #b28847;
					font-size: 32/@vw;
					padding-left: 30/@vw;
					box-sizing: border-box;
				}

				.mainOnebox_main_list_name2 {
					max-width: 414px;
					margin-top: 30/@vw;
					color: #1a1a1a;
					font-size: 24/@vw;
					padding-left: 30/@vw;
				}

			}

		}
	}
</style>
